import React, { useState, useEffect } from 'react'
import { S3CLOUD_CLOUDFRONT } from '../../../../../config/s3directories';
import { ARROWRIGHT_SMALL, CURRENCY_MAP, COUNTRY_RELATED_DATA, WEBSITE_URL } from '../../../../../config/constants';
import { withRouter } from "react-router-dom";
import { Checkdevice } from '../../../../../components';
import { Retrieve_personal_info, iconwrapper } from '../../../../../config/commonfunctions';
import { PLANNING_CHECKLIST_ICON, PLANNING_BUDGET_ICON, PLANNING_TIMELINE_ICON, PLANNING_INVITE_ICON, PLANNING_SEATING_ICON, PLANNING_GUESTBOOK_ICON, PLANNING_QR_ICON, RIGHTARROW_ICON, PLAY_ICON, } from '../../../../../config/svgicons';
import { USER_READDASHBOARDITEM } from '../../../../../config/api';
import axios from 'axios'
import './Dashboard.css'
import { allimages } from '../../../../../assets/invitationcard/index1';

//boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
// boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
const allborder = { boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }
const iconcss = { width: 23, height: 23, display: 'flex', placeContent: 'center', color: 'var(--maindark)' }

function getDate(date) {
    if (!date) return '';

    return new Date(date).toLocaleDateString("en-SG", {
        dateStyle: "full"
    });
}

function getDays(date) {
    if (!date) return '';

    const now = new Date();
    const target = new Date(date);

    // Remove time portion (avoid partial-day issues)
    now.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    const diffMs = target - now;
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    return diffDays;
}

function Dot({ allids, item, id, left, right }) {

    return <div className='dashboard-radioroot'>
        <button className='dashboard-arrowbtn' onClick={left}>◀</button>
        <div className='dashboard-dotroot'>
            {(allids && allids[item])
                ? allids[item].map((local_budget_id, i) => {
                    if (local_budget_id === id) {
                        return <div key={local_budget_id} className='dashboard-dotselected' />
                    }
                    else {
                        return <div key={local_budget_id} className='dashboard-dot' />
                    }
                })
                : null}
        </div>
        <button className='dashboard-arrowbtn' onClick={right}>▶</button>
    </div>
}

function leftandright(where, id, allids, leftorright, updateDashboard) {
    let nextid = ''
    if (leftorright === 'left') {
        nextid = allids[where][allids[where].indexOf(id) - 1]
    }
    else {
        nextid = allids[where][allids[where].indexOf(id) + 1]
    }

    if (nextid) {
        try {
            const { token } = Retrieve_personal_info()
            axios({
                method: 'POST',
                url: USER_READDASHBOARDITEM,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                data: { nextid: nextid, where: where, }
            })
                .then((result) => {
                    const { item } = result.data
                    updateDashboard(item, where)
                })
                .catch(e => {
                    console.log('e', e)
                })
        }
        catch (e) {
            console.log(e)
        }
    }
    else {
        return
    }

}

function Dashboard(props) {

    const device = Checkdevice()
    const [name, setName] = useState('')
    const [spousename, setSpousename] = useState('')
    const [date, setDate] = useState('')
    const [days, setDays] = useState('')
    const [favourite, setFavourite] = useState([])
    const [usertype, setUsertype] = useState('')
    const [dashboard, setDashboard] = useState({
        // dashboard: { // every save from [ Checklist ] [ Budget Tracker ] [ Timeline Itinerary ] [ Site Builder & Guest List ] [ Seating Chart ]
        //     type: Object,
        //     default: {
        //       cl: ['', '', 0, 0], // checklist :         [checklist_id, name, num_checked, total]                                              update_checklist | create_checklist | remove_singlechecklist                         
        //       bt: ['', '', 0, 0], // budget tracker :    [budget_id, name, budget, totalcost]                                                          update_budget    | create_budget    | remove_singlebudget                           
        //       tl: ['', '', ''], // timeline :            [timeline_id, urlhandler, passcode]                                                   update_timeline  | create_timeline  | remove_singletimeline                          
        //       web: ['', '', ''], // website :            [id, urlhandler, passcode]                                                            savecard         | createcard       | remov_single_ic                                 
        //       sc: ['', '', 0, 0, 0, ''], // seatchart :  [id, urlhandler, num_totalguests, num_seatedguests, num_nonseatedguests, passcode]    update_seat      | create_seat      | remove_singleseat                            
        //       gb: ['', '', ''], // guestbook :           [id, urlhandler, passcode]
        //       db: ['', '', ''] // drawbook :             [id, urlhandler, passcode, passcodemod]
        //       // gul has moved to get_userdb api --- gul: [], // guestlist :  [id, num_accept, num_reject, num_noreply]                                               addguest         | editguest        | removeguest             | <----- invitationcard : answerrsvpaddnew -----> importcsv
        //     }
        //   }  
    })
    const [rsvpacceptancerate, setRsvpacceptancerate] = useState('')
    const [rsvpacceptnum, setRsvpacceptnum] = useState('')
    const [rsvprejectnum, setRsvprejectnum] = useState('')
    const [rsvpnoreplynum, setRsvpnoreplynum] = useState('')

    const [timelineurl, setTimelineurl] = useState('')
    const [timelinepasscode, setTimelinepasscode] = useState('')
    const [timelinesnippets, setTimelinesnippets] = useState('')
    const [timelinetotalobjs, setTimelinetotalobjs] = useState('')
    const [timelinecornerimg, setTimelinebanner] = useState('')
    const [timelinebanner, setTimelinecornerimg] = useState('')

    const [budget, setBudget] = useState(0)
    const [totalcost, setTotalcost] = useState(0)
    const [budgetremain, setBudgetremain] = useState(0)

    const [location, setLocation] = useState('')
    const [capabbrevlocation, setCapabbrevlocation] = useState('')
    const [img, setImg] = useState('')

    // vendortype market
    const [selectedvt_vendorobj_map, setSelectedvt_vendorobj_map] = useState({})
    const [vendorobj_arr, setVendorobj_arr] = useState([])

    const [allids, setAllids] = useState({
        // budget_ids: budget_ids,
        // invitationcard_ids: invitationcard_ids,
        // seat_ids: seat_ids,
        // checklist_ids: checklist_ids,
        // db_ids: db_ids,
        // tl_ids: tl_ids
    })

    const [rsvpid, setRsvpid] = useState('')
    const [budgetid, setBudgetid] = useState('')
    const [seatchartid, setSeatchartid] = useState('')
    const [checklistid, setChecklistid] = useState('')
    const [drawbookid, setDrawbookid] = useState('')
    const [timelineid, setTimelineid] = useState('')

    useEffect(() => {
        if (props.data && props.data.message === 'SUCCESS') {

            const { location, name, spousename, selectedvt_vendorobj_map, vendorobj_arr, date, favourite, usertype, dashboard, img, allids } = props.data

            // console.log('allids', allids)

            // const [seatchartid, setSeatchartid] = useState('')
            // const [checklistid, setChecklistid] = useState('')
            // const [drawbookid, setDrawbookid] = useState('')

            setName(name)
            setSpousename(spousename)
            setSelectedvt_vendorobj_map(selectedvt_vendorobj_map)
            setVendorobj_arr(vendorobj_arr)
            setDate(getDate(date))
            setDays(getDays(date))

            setFavourite(favourite)
            setUsertype(usertype)
            setDashboard(dashboard)
            console.log('dashboard', dashboard)
            // console.log(dashboard['gul'][0] === dashboard['web'][0] )
            // rsvp acceptance card 
            setRsvpid(dashboard['gul'][0]) // gul and web share the same id 
            setRsvpacceptancerate(Math.floor((dashboard['gul'][1] / (dashboard['gul'][1] + dashboard['gul'][2] + dashboard['gul'][3])) * 100) + '%')
            setRsvpacceptnum(dashboard['gul'][1])
            setRsvprejectnum(dashboard['gul'][2])
            setRsvpnoreplynum(dashboard['gul'][3])


            // budget card
            setBudgetid(dashboard['bt'][0])
            setBudget(dashboard['bt'][2])
            setTotalcost(dashboard['bt'][3])
            setBudgetremain(parseInt(dashboard['bt'][2]) - parseInt(dashboard['bt'][3]))

            // seatchart 
            setSeatchartid(dashboard['sc'][0])

            // checklist
            setChecklistid(dashboard['cl'][0])

            // guestbook
            setDrawbookid(dashboard['db'][0])

            // timeline
            setTimelineid(dashboard['tl'][0])
            setTimelineurl(dashboard['tl'] && dashboard['tl'][1] ? dashboard['tl'][1] : '')
            setTimelinepasscode(dashboard['tl'] && dashboard['tl'][2] ? dashboard['tl'][2] : '')
            setTimelinesnippets(dashboard['tl'] && dashboard['tl'][3] ? dashboard['tl'][3] : '')
            setTimelinetotalobjs(dashboard['tl'] && dashboard['tl'][4] ? dashboard['tl'][4] : '')
            setTimelinecornerimg(dashboard['tl'] && dashboard['tl'][5] ? dashboard['tl'][5] : '')
            setTimelinebanner(dashboard['tl'] && dashboard['tl'][6] ? dashboard['tl'][6] : '')

            setLocation(location)
            setCapabbrevlocation(COUNTRY_RELATED_DATA[location]['capabbrev'])
            setImg(img)

            setAllids(JSON.parse(JSON.stringify(allids)))

        }
    }, [props])

    const VENDORS = [
        { id: 1, category: "Photography", name: "Creative Captures", rating: 4.9, status: "Hired", estimate: "$3,500.00", avatar: "📸" },
        { id: 2, category: "Catering", name: "Gourmet Delights", rating: 4.8, status: "Hired", estimate: "$8,900.00", avatar: "🍽️" },
        { id: 3, category: "Florist", name: "Petal & Stem", rating: 4.7, status: "Contract Sent", estimate: "$1,800.00", avatar: "💐" },
        { id: 4, category: "Cinematography", name: "Visual Memoirs", rating: 5.0, status: "Exploring", estimate: "$4,200.00", avatar: "🎬" },
    ]

    // ── Helpers ────────────────────────────────────────────────────────────────
    const statusColor = (s) => ({
        Completed: { bg: "#e8f5e9", color: "#2e7d32" },
        "In Progress": { bg: "#fff8e1", color: "#f57f17" },
        Pending: { bg: "#f5f5f5", color: "#9e9e9e" },
        Hired: { bg: "#e3f2fd", color: "#1565c0" },
        "Contract Sent": { bg: "#fff3e0", color: "#e65100" },
        Exploring: { bg: "#f5f5f5", color: "#757575" },
    }[s] || { bg: "#eee", color: "#333" })

    const generatetoprighticon = (icon, name, explain, smallicon) => {
        const mindim = 60

        return <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

            {/* <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', top: 0, right: 0 }}>
                <div className='dashboard-icondivider1' style={{ marginTop: 0, width: mindim }} />
                <div className='dashboard-icondivider1' style={{ marginTop: 0, width: mindim / 2, right: mindim, borderBottomLeftRadius: '100%' }} />
            </div>
            <div className='dashboard-icondivider1' style={{ marginTop: 5, width: mindim - 5 }} />
            <div className='dashboard-icondivider1' style={{ marginTop: 10, width: mindim - 10 }} />
            <div className='dashboard-icondivider1' style={{ marginTop: 15, width: mindim - 15 }} />
            <div className='dashboard-icondivider1' style={{ marginTop: 20, width: mindim - 20 }} />

            <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', top: 0, right: 0 }}>
                <div className='dashboard-icondivider2' style={{ marginRight: 0, height: mindim }} />
                <div className='dashboard-icondivider2' style={{ marginRight: 0, height: mindim / 2, top: mindim, borderBottomLeftRadius: '100%' }} />
            </div>
            <div className='dashboard-icondivider2' style={{ marginRight: 5, height: mindim - 5 }} />
            <div className='dashboard-icondivider2' style={{ marginRight: 10, height: mindim - 10 }} />
            <div className='dashboard-icondivider2' style={{ marginRight: 15, height: mindim - 15 }} />
            <div className='dashboard-icondivider2' style={{ marginRight: 20, height: mindim - 20 }} /> */}


            <div style={{ display: "flex", flexDirection: "column", }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontWeight: 700, fontSize: 15, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>{name}</span>
                    <span style={{ fontSize: 20 }}>{smallicon}</span>
                </div>
                <span style={{ fontSize: 12, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>{explain}</span>
            </div>



            <div className='dashboard-toprighticonroot'>{iconwrapper(icon, iconcss)}</div>
        </div>
    }

    function updateDashboard(dashboard, where) {
        setDashboard((local_dashboard) => {
            if (where === 'budget_ids') {
                // budget card
                setBudgetid(dashboard['bt'][0])
                setBudget(dashboard['bt'][2])
                setTotalcost(dashboard['bt'][3])
                setBudgetremain(parseInt(dashboard['bt'][2]) - parseInt(dashboard['bt'][3]))

                return {
                    ...local_dashboard,
                    bt: {
                        ...dashboard.bt
                    }
                }
            }
            else if (where === 'invitationcard_ids') {
                setRsvpid(dashboard['web'][0])
                setRsvpacceptancerate(Math.floor((dashboard['gul'][1] / (dashboard['gul'][1] + dashboard['gul'][2] + dashboard['gul'][3])) * 100) + '%')
                setRsvpacceptnum(dashboard['gul'][1])
                setRsvprejectnum(dashboard['gul'][2])
                setRsvpnoreplynum(dashboard['gul'][3])

                return {
                    ...local_dashboard,
                    web: {
                        ...dashboard.web
                    },
                    gul: {
                        ...dashboard.gul
                    }
                }
            }
            else if (where === 'seat_ids') {
                setSeatchartid(dashboard['sc'][0])
                return {
                    ...local_dashboard,
                    sc: {
                        ...dashboard.sc
                    }
                }
            }
            else if (where === 'checklist_ids') {
                setChecklistid(dashboard['cl'][0])
                return {
                    ...local_dashboard,
                    cl: {
                        ...dashboard.cl
                    }
                }
            }
            else if (where === 'db_ids') {
                setDrawbookid(dashboard['db'][0])
                return {
                    ...local_dashboard,
                    db: {
                        ...dashboard.db
                    }
                }
            }
            else if (where === 'tl_ids') {
                setTimelineid(dashboard['tl'][0])
                setTimelineurl(dashboard['tl'] && dashboard['tl'][1] ? dashboard['tl'][1] : '')
                setTimelinepasscode(dashboard['tl'] && dashboard['tl'][2] ? dashboard['tl'][2] : '')
                setTimelinesnippets(dashboard['tl'] && dashboard['tl'][3] ? dashboard['tl'][3] : '')
                setTimelinetotalobjs(dashboard['tl'] && dashboard['tl'][4] ? dashboard['tl'][4] : '')
                setTimelinecornerimg(dashboard['tl'] && dashboard['tl'][5] ? dashboard['tl'][5] : '')
                setTimelinebanner(dashboard['tl'] && dashboard['tl'][6] ? dashboard['tl'][6] : '')

                return {
                    ...local_dashboard,
                    tl: {
                        ...dashboard.tl
                    }
                }
            }
            return local_dashboard
        })
    }

    // ── Sub-components ─────────────────────────────────────────────────────────

    function ProfileCard() {
        // return <div style={{ background: "#fff", borderRadius: 16, padding: "24px 28px 24px 28px", flex: "1 1 500px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", display: "flex", flexDirection: "column", position: "relative", overflow: "hidden", gap: 12 }}>
        //padding: "0px 28px 24px 28px",
        return <div style={{ ...allborder, minHeight: 282, background: "#fff", borderRadius: 16, flex: "1 1 500px", display: "flex", flexDirection: "column", position: "relative", overflow: "hidden", gap: 12 }}>

            <span className='dashboard-usertype' >
                <div>{usertype}</div>
                {iconwrapper(ARROWRIGHT_SMALL, { display: 'flex', placeContent: 'center', placeItems: 'center', width: 20, height: 20 })}
            </span>

            <div style={{ padding: '0px 24px 48px 24px', display: "flex", flexDirection: 'column', gap: 12 }}>

                <div style={{ display: "flex", gap: 32, flexWrap: "wrap", alignItems: "flex-start" }}>

                    <div style={{ flex: "1 1 250px", display: "flex", flexDirection: "column", gap: 12 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontWeight: 700, fontSize: 15, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>Profile</span>
                            <span style={{ fontSize: 20 }}>👥</span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div
                                style={{ width: 80, height: 80, borderRadius: "50%", border: "2px dashed #ddd", cursor: "pointer", overflow: "hidden", flexShrink: 0, background: "#fafafa", display: "flex", alignItems: "center", justifyContent: "center", transition: "border 0.2s, background 0.2s", }}
                                onDragOver={e => { e.preventDefault(); setDragging(true) }}
                                onDragLeave={() => setDragging(false)}
                            >
                                {img
                                    ? <img src={S3CLOUD_CLOUDFRONT + img} alt="profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    : <span style={{ fontSize: 28 }}>👤</span>
                                }
                            </div>
                            <div style={{ paddingLeft: 10 }}>
                                <div style={{ fontSize: 14, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", color: 'var(--maindark)', marginTop: 5 }}>
                                    {usertype === 'Wedding' ? name + ' & ' + spousename : name}
                                </div>
                                <div style={{ fontSize: 14, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", color: 'var(--maindark)' }}>
                                    {location + ' ' + capabbrevlocation}
                                </div>
                            </div>
                        </div>
                    </div>

                    {device === 'MOBILE' || device === 'TABLET'
                        ? null
                        : <div className="dashboard-divider-vertical" style={{ width: 1, background: "var(--lightdark)", alignSelf: "stretch", minHeight: 80 }} />}

                    <div style={{ flex: "1 1 250px", display: "flex", flexDirection: "column", gap: 12, }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontWeight: 700, fontSize: 15, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>Days to {usertype}</span>
                            <span style={{ fontSize: 20 }}>📅</span>
                        </div>

                        {(days.toString().length > 0 && date.toString().length > 0) ?
                            <>
                                <div style={{ fontSize: 32, fontWeight: 700, color: "var(--maindark)", fontFamily: "'Playfair Display', serif", lineHeight: 1.1 }}>{days}</div>
                                <div style={{ fontSize: 12, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>{date}</div>
                            </>
                            // : <span style={{ color: 'var(--subtitledark)' }}>Date to be confirmed.</span>}
                            : <div className='dashboard-websiteurllabel' style={{ backgroundColor: '#fff', border: '1px dashed var(--lightdark)' }}>
                                Date to be confirmed.
                            </div>}

                    </div>

                </div>

                <div style={{ display: "flex", gap: 8 }}>
                    <button className='dashboard-editbtn' onClick={() => props.history.push('/profile')}>
                        Edit
                    </button>
                </div>
            </div>



        </div >
    }


    function BudgetCard() {
        const spentPct = budget > 0 ? Math.min((totalcost / budget) * 100, 100) : 0
        const remainPct = 100 - spentPct

        return (
            <div style={{ ...allborder, minHeight: 245, background: "#fff", borderRadius: 16, padding: "24px 24px 48px 24px", flex: "1 1 255px", display: "flex", flexDirection: "column", gap: 12, position: "relative", overflow: "hidden" }}>

                {generatetoprighticon(PLANNING_BUDGET_ICON, 'Budget Tracker', 'Track spending and stay on budget.', '📊')}

                {budgetid.length > 0
                    ? <>
                        <div style={{ fontSize: 32, fontWeight: 700, color: "var(--maindark)", fontFamily: "'Playfair Display', serif", lineHeight: 1.1 }}>
                            {budget} <span style={{ fontSize: 16, fontWeight: 400 }}>{CURRENCY_MAP[location]}</span>
                        </div>

                        {/* Single-line bar chart */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 'inherit' }}>
                            <div style={{ display: "flex", borderRadius: 6, overflow: "hidden", height: 10 }}>
                                <div style={{
                                    width: `${spentPct}%`,
                                    background: spentPct >= 90 ? "#e74c3c" : spentPct >= 70 ? "#f39c12" : "var(--maindark)",
                                    transition: "width 0.6s ease"
                                }} />
                                <div style={{
                                    width: `${remainPct}%`,
                                    background: "#e8e8e8",
                                    transition: "width 0.6s ease"
                                }} />
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: 'column' }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                    <div style={{ width: 8, height: 8, borderRadius: "50%", background: spentPct >= 90 ? "#e74c3c" : spentPct >= 70 ? "#f39c12" : "var(--maindark)" }} />
                                    <span style={{ fontSize: 11, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>Spent {totalcost.toString()} {CURRENCY_MAP[location]}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                    <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#e8e8e8", border: "1px solid #ccc" }} />
                                    <span style={{ fontSize: 11, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>Left {budgetremain} {CURRENCY_MAP[location]}</span>
                                </div>
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                className='dashboard-editbtn'
                                onClick={() => props.history.push('/tools/budgetbuilder/' + budgetid + '/edit')}
                            >
                                Edit
                            </button>
                        </div>

                    </>
                    : <button
                        className='dashboard-create'
                        onClick={() => props.history.push('/tools/budget')}
                    >

                        + Create Budget
                    </button>}

                <Dot allids={allids} item={'budget_ids'} id={budgetid} left={() => { leftandright('budget_ids', budgetid, allids, 'left', updateDashboard) }} right={() => { leftandright('budget_ids', budgetid, allids, 'right', updateDashboard) }} />

            </div>
        )
    }

    function WebsiteGuestlist() {

        const websiteUrl = dashboard['web'] && dashboard['web'][1] ? dashboard['web'][1] : '';
        const passcode = dashboard['web'] && dashboard['web'][2] ? dashboard['web'][2] : '';
        const templatetype = dashboard['web'] && dashboard['web'][3] ? dashboard['web'][3] : 0;
        const prebuildtemplatedesign_map = dashboard['web'] && dashboard['web'][4] ? dashboard['web'][4] : {};
        const styletype = dashboard['web'] && dashboard['web'][5] ? dashboard['web'][5] : '';
        const stylesep = dashboard['web'] && dashboard['web'][6] ? dashboard['web'][6] : '';

        let banner = ''
        let cornerimg = ''

        if (templatetype === 1) {
            banner = stylesep
            cornerimg = allimages.get(styletype)['corner']['topright']['url']
        }
        else if (templatetype === 2 && Object.keys(prebuildtemplatedesign_map).length > 0 && prebuildtemplatedesign_map[templatetype] && prebuildtemplatedesign_map[templatetype].styletype) {
            banner = prebuildtemplatedesign_map[templatetype].stylesep
            cornerimg = allimages.get(prebuildtemplatedesign_map[templatetype].styletype)['corner']['topleft']['url']
        }

        return <div style={{ ...allborder, background: "#fff", borderRadius: 16, padding: "24px 24px 48px 24px", display: "flex", flexDirection: "column", gap: 12, position: 'relative', overflow: 'hidden', }}>
            {generatetoprighticon(PLANNING_INVITE_ICON)}

            {rsvpid.length > 0
                ? <div style={{ display: "flex", gap: 32, flexWrap: "wrap", alignItems: "flex-start" }}>

                    <div style={{ flex: "1 1 280px", display: "flex", flexDirection: "column", gap: 12, }}>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span style={{ fontWeight: 700, fontSize: 15, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>RSVP Website</span>
                                <span style={{ fontSize: 20 }}>🌐</span>
                            </div>
                            <span style={{ fontSize: 12, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>Share your wedding details with guests.</span>
                        </div>

                        {(cornerimg.length > 0 && banner.length > 0)
                            ? <div className='dashboard-templatedesignroot'>
                                <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Design</div>
                                <div className='dashboard-templatedesign'>
                                    <img className='dashboard-designart' src={cornerimg} />
                                    {/* <div className="dashboard-divider-vertical" style={{ width: 1, background: "var(--lightdark)", alignSelf: "stretch", minHeight: '100%' }} /> */}
                                    <img className='dashboard-designsep' src={banner} />
                                </div>
                            </div>
                            : <div className='dashboard-templatedesignroot'>
                                <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Design</div>
                                <div className='dashboard-templatedesign' style={{ width: '100%' }}>
                                    EMPTY
                                </div>
                            </div>}

                        <div className='dashboard-templatedesignroot'>
                            <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>URL</div>
                            <div className='dashboard-websiteurllabel'>
                                {WEBSITE_URL + '/invitation/' + websiteUrl + '/passcode=' + passcode}
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                className='dashboard-redirectbtn'
                                onClick={() => window.open('/invitation/' + websiteUrl + '/passcode=' + passcode, '_blank')}
                            >
                                View
                            </button>
                            <button
                                className='dashboard-editbtn'
                                onClick={() => window.open('/tools/invitationbuilder/' + rsvpid + '/edit', '_blank')}
                            >
                                Edit
                            </button>
                        </div>

                    </div>

                    {/* Divider - hidden when wrapped */}
                    {device === 'MOBILE' || device === 'TABLET'
                        ? null
                        : <div className="dashboard-divider-vertical" style={{ width: 1, background: "var(--lightdark)", alignSelf: "stretch", minHeight: 80 }} />}



                    <div style={{ flex: "1 1 280px", display: "flex", flexDirection: "column", gap: 12, }}>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span style={{ fontWeight: 700, fontSize: 15, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>Guest List</span>
                                <span style={{ fontSize: 20 }}>🪑</span>
                            </div>
                            <span style={{ fontSize: 12, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>Manage RSVPs and track responses.</span>
                        </div>

                        {(rsvpacceptnum + rsvprejectnum + rsvpnoreplynum) > 0
                            ? <>
                                <div style={{ display: "flex", flexDirection: "column", placeItems: 'center' }}>
                                    <div style={{ fontSize: 32, fontWeight: 700, color: "var(--maindark)", fontFamily: "'Playfair Display', serif", lineHeight: 1.1, display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                                        {rsvpacceptancerate}
                                    </div>
                                    <span style={{ fontSize: 11, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", paddingTop: 5 }}>RSVP Acceptance Rate</span>
                                </div>

                                <div style={{ width: '100%', background: "var(--lightdark)", alignSelf: "stretch", minHeight: 1 }} />

                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 40 }}>
                                    <div style={{ display: "flex", flexDirection: "column", width: "33%", paddingLeft: 16, placeItems: 'center' }}>
                                        <span style={{ fontSize: 24, fontWeight: 700, color: "var(--maindark)", fontFamily: "'Playfair Display', serif", lineHeight: 1 }}>
                                            {rsvpacceptnum}
                                        </span>
                                        <span style={{ fontSize: 11, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", paddingTop: 5 }}>Accepted</span>
                                    </div>
                                    <div style={{ width: 1, height: 30, background: "var(--lightdark)" }} />
                                    <div style={{ display: "flex", flexDirection: "column", width: "33%", paddingLeft: 16, placeItems: 'center' }}>
                                        <span style={{ fontSize: 24, fontWeight: 700, color: "#f39c12", fontFamily: "'Playfair Display', serif", lineHeight: 1 }}>
                                            {rsvprejectnum}
                                        </span>
                                        <span style={{ fontSize: 11, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", paddingTop: 5 }}>Decline</span>
                                    </div>
                                    <div style={{ width: 1, height: 30, background: "var(--lightdark)" }} />
                                    <div style={{ display: "flex", flexDirection: "column", width: "33%", paddingLeft: 16, placeItems: 'center' }}>
                                        <span style={{ fontSize: 24, fontWeight: 700, color: "var(--maindark)", fontFamily: "'Playfair Display', serif", lineHeight: 1 }}>
                                            {rsvpnoreplynum}
                                        </span>
                                        <span style={{ fontSize: 11, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", paddingTop: 5 }}>No Reply</span>
                                    </div>
                                </div>

                                <div style={{ display: "flex", gap: 8 }}>
                                    <button className='dashboard-editbtn' onClick={() => window.open('/tools/invitationbuilder/' + rsvpid + '/edit/gl', '_blank')}>
                                        Edit
                                    </button>
                                </div>
                            </>
                            : < >
                                <div className='dashboard-websiteurllabel' style={{ backgroundColor: '#fff', border: '1px dashed var(--lightdark)' }}>Nothing to show just yet — need more data 🙂</div>
                                <div style={{ display: "flex", gap: 8 }}>
                                    <button className='dashboard-editbtn' onClick={() => window.open('/tools/invitationbuilder/' + rsvpid + '/edit/gl', '_blank')}>
                                        Edit
                                    </button>
                                </div>
                            </>
                        }
                    </div>

                </div>
                : <div style={{ display: "flex", gap: 32, flexWrap: "wrap", alignItems: "flex-start" }}>

                    <div style={{ flex: "1 1 280px", display: "flex", flexDirection: "column", gap: 12, }}>


                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span style={{ fontWeight: 700, fontSize: 15, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>RSVP Website</span>
                                <span style={{ fontSize: 20 }}>🌐</span>
                            </div>
                            <span style={{ fontSize: 12, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>Share your wedding details with guests.</span>
                        </div>


                        <button
                            className='dashboard-create'
                            onClick={() => props.history.push('/tools/invitation')}
                        >
                            + Create Website
                        </button>

                    </div>

                    {/* Divider - hidden when wrapped */}
                    {device === 'MOBILE' || device === 'TABLET'
                        ? null
                        : <div className="dashboard-divider-vertical" style={{ width: 1, background: "var(--lightdark)", alignSelf: "stretch", minHeight: 80 }} />}


                    <div style={{ flex: "1 1 280px", display: "flex", flexDirection: "column", gap: 12, }}>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span style={{ fontWeight: 700, fontSize: 15, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>Guest List</span>
                                <span style={{ fontSize: 20 }}>🪑</span>
                            </div>
                            <span style={{ fontSize: 12, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>Manage RSVPs and track responses.</span>
                        </div>

                        <button
                            className='dashboard-create'
                            onClick={() => props.history.push('/tools/invitation')}
                        >
                            + Create RSVP website
                        </button>
                    </div>

                </div>}

            <Dot allids={allids} item={'invitationcard_ids'} id={rsvpid} left={() => { leftandright('invitationcard_ids', rsvpid, allids, 'left', updateDashboard) }} right={() => { leftandright('invitationcard_ids', rsvpid, allids, 'right', updateDashboard) }} />

        </div>

    }

    function SeatingCard() {

        const seatingurl = dashboard['sc'] && dashboard['sc'][1] ? dashboard['sc'][1] : '';

        const totalGuests = dashboard['sc'] && dashboard['sc'][2] ? dashboard['sc'][2] : 0;
        const seatedGuests = dashboard['sc'] && dashboard['sc'][3] ? dashboard['sc'][3] : 0;
        const nonSeatedGuests = dashboard['sc'] && dashboard['sc'][4] ? dashboard['sc'][4] : 0;

        const seatingpasscode = dashboard['sc'] && dashboard['sc'][5] ? dashboard['sc'][5] : '';

        const banner = dashboard['sc'] && dashboard['sc'][6] ? dashboard['sc'][6] : '';
        const cornerimg = dashboard['sc'] && dashboard['sc'][7] ? dashboard['sc'][7] : '';


        const confirmedPct = totalGuests > 0 ? (seatedGuests / totalGuests) * 100 : 0
        const r = 60, cx = 70, cy = 70, stroke = 5
        const circ = 2 * Math.PI * r

        const MIN_PCT = 8
        const displayPct = seatedGuests > 0 ? Math.max(confirmedPct, MIN_PCT) : 0
        const dash = (displayPct / 100) * circ

        return (
            <div style={{ ...allborder, background: "#fff", borderRadius: 16, padding: '24px 24px 48px 24px', display: "flex", flexDirection: "column", gap: 12, position: 'relative', overflow: 'hidden' }}>
                {generatetoprighticon(PLANNING_SEATING_ICON, 'Seating Chart', 'Arrange and assign guest seating.', '')}
                {seatchartid.length > 0
                    ? <>
                        {(cornerimg.length > 0 && banner.length > 0)
                            ? <div className='dashboard-templatedesignroot'>
                                <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Design</div>
                                <div className='dashboard-templatedesign'>
                                    <img className='dashboard-designart' src={cornerimg} />
                                    {/* <div className="dashboard-divider-vertical" style={{ minWidth: 1, background: "var(--lightdark)", alignSelf: "stretch", minHeight: '100%' }} /> */}
                                    <img className='dashboard-designsep' src={banner} />
                                </div>
                            </div>
                            : <div className='dashboard-templatedesignroot'>
                                <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Design</div>
                                <div className='dashboard-templatedesign' style={{ width: '100%' }}>
                                    EMPTY
                                </div>
                            </div>}


                        <div className='dashboard-templatedesignroot'>
                            <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>URL</div>
                            <div className='dashboard-websiteurllabel'>
                                {WEBSITE_URL + '/seatingchartlookup/' + seatingurl + '/passcode=' + seatingpasscode}
                            </div>
                        </div>



                        <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Chart</div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <svg width={140} height={140}>
                                <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e8e8e8" strokeWidth={stroke} />
                                {seatedGuests > 0 && (
                                    <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--maindark)" strokeWidth={stroke}
                                        strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
                                        transform={`rotate(-90 ${cx} ${cy})`} />
                                )}
                                <text x={cx} y={cy - 6} textAnchor="middle" fontSize={22} fontWeight={700} fill="var(--maindark)" fontFamily="'Playfair Display', serif">{totalGuests}</text>
                                <text x={cx} y={cy + 14} textAnchor="middle" fontSize={11} fill="var(--subtitledark)" fontFamily="'DM Sans', sans-serif">Total Guests</text>
                            </svg>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            {[
                                { label: "Seated", count: seatedGuests, color: "var(--maindark)" },
                                { label: "Unseated", count: nonSeatedGuests, color: "#ccc" }
                            ].map(row => (
                                <div key={row.label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <div style={{ width: 10, height: 10, borderRadius: "50%", background: row.color }} />
                                        <span style={{ fontSize: 13, color: "#555", fontFamily: "'DM Sans', sans-serif" }}>{row.label}</span>
                                    </div>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{row.count}</span>
                                </div>
                            ))}
                            <div key={'totalguestslabel'} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 13, color: "#555", fontFamily: "'DM Sans', sans-serif" }}>Total Guests</span>
                                </div>
                                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{totalGuests}</span>
                            </div>
                        </div>

                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                className='dashboard-redirectbtn'
                                onClick={() => window.open('/seatingchartlookup/' + seatingurl + '/passcode=' + seatingpasscode, '_blank')}
                            >
                                View
                            </button>
                            <button
                                className='dashboard-editbtn'
                                onClick={() => window.open('/tools/seatingchartbuilder/' + seatchartid + '/edit', '_blank')}
                            >
                                Edit
                            </button>
                        </div>
                    </>
                    : <button
                        className='dashboard-create'
                        onClick={() => props.history.push('/tools/seatingchart')}
                    >

                        + Create Seating Chart
                    </button>}


                <Dot allids={allids} item={'seat_ids'} id={seatchartid} left={() => { leftandright('seat_ids', seatchartid, allids, 'left', updateDashboard) }} right={() => { leftandright('seat_ids', seatchartid, allids, 'right', updateDashboard) }} />
            </div>
        )
    }

    function ChecklistCard() {
        const checklistname = dashboard['cl'] && dashboard['cl'][1] ? dashboard['cl'][1] : '';
        const numcheck = dashboard['cl'] && dashboard['cl'][2] ? dashboard['cl'][2] : 0;
        const total = dashboard['cl'] && dashboard['cl'][3] ? dashboard['cl'][3] : 0;

        const numunchecked = total - numcheck;

        const confirmedPct = total > 0 ? (numcheck / total) * 100 : 0;
        const r = 60, cx = 70, cy = 70, stroke = 5;
        const circ = 2 * Math.PI * r;

        const MIN_PCT = 8;
        const displayPct = numcheck > 0 ? Math.max(confirmedPct, MIN_PCT) : 0;
        const dash = (displayPct / 100) * circ;

        return (
            <div style={{ ...allborder, background: "#fff", borderRadius: 16, padding: '24px 24px 48px 24px', display: "flex", flexDirection: "column", gap: 12, position: 'relative', overflow: 'hidden' }}>
                {generatetoprighticon(PLANNING_CHECKLIST_ICON, 'Checklist', 'Stay on top of every wedding task.', '')}

                {checklistid.length > 0
                    ? <>
                        <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Chart</div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <svg width={140} height={140}>
                                <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e8e8e8" strokeWidth={stroke} />
                                {numcheck > 0 && (
                                    <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--maindark)" strokeWidth={stroke}
                                        strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
                                        transform={`rotate(-90 ${cx} ${cy})`} />
                                )}
                                <text x={cx} y={cy - 6} textAnchor="middle" fontSize={22} fontWeight={700} fill="var(--maindark)" fontFamily="'Playfair Display', serif">{total}</text>
                                <text x={cx} y={cy + 14} textAnchor="middle" fontSize={11} fill="var(--subtitledark)" fontFamily="'DM Sans', sans-serif">Total Tasks</text>
                            </svg>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            {[
                                { label: "Completed", count: numcheck, color: "var(--maindark)" },
                                { label: "Remaining", count: numunchecked, color: "#ccc" }
                            ].map(row => (
                                <div key={row.label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <div style={{ width: 10, height: 10, borderRadius: "50%", background: row.color }} />
                                        <span style={{ fontSize: 13, color: "#555", fontFamily: "'DM Sans', sans-serif" }}>{row.label}</span>
                                    </div>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{row.count}</span>
                                </div>
                            ))}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 13, color: "#555", fontFamily: "'DM Sans', sans-serif" }}>Total Tasks</span>
                                </div>
                                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{total}</span>
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                className='dashboard-editbtn'
                                onClick={() => window.open('/tools/checklistbuilder/' + checklistid + '/edit', '_blank')}

                            >
                                Edit
                            </button>
                        </div>
                    </>
                    : <button
                        className='dashboard-create'
                        onClick={() => props.history.push('/tools/checklist')}
                    >

                        + Create Checklist
                    </button>}

                <Dot allids={allids} item={'checklist_ids'} id={checklistid} left={() => { leftandright('checklist_ids', checklistid, allids, 'left', updateDashboard) }} right={() => { leftandright('checklist_ids', checklistid, allids, 'right', updateDashboard) }} />

            </div>
        )
    }

    function DrawbookCard() {
        // id, urlhandler, passcode, passcodemod
        const id = dashboard['db'] && dashboard['db'][0] ? dashboard['db'][0] : '';
        const url = dashboard['db'] && dashboard['db'][1] ? dashboard['db'][1] : '';
        const passcode = dashboard['db'] && dashboard['db'][2] ? dashboard['db'][2] : '';
        const passcodemod = dashboard['db'] && dashboard['db'][3] ? dashboard['db'][3] : '';
        const totalentry = dashboard['db'] && dashboard['db'][4] ? dashboard['db'][4] : 0;
        const maxentry = dashboard['db'] && dashboard['db'][5] ? dashboard['db'][5] : 0;
        const purchase = dashboard['db'] && dashboard['db'][5] ? dashboard['db'][6] : {};

        let status_dom = Object.keys(purchase).length > 0 && purchase.status === 'BOUGHT'
            ? <div className='dashboard-planroot'>
                <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Plan</div>
                <div className='dashboard-websiteurllabel'>{'Premium'}</div>
            </div>
            : null

        const confirmedPct = maxentry > 0 ? (totalentry / maxentry) * 100 : 0;
        const r = 60, cx = 70, cy = 70, stroke = 5;
        const circ = 2 * Math.PI * r;

        const MIN_PCT = 8;
        const displayPct = totalentry > 0 ? Math.max(confirmedPct, MIN_PCT) : 0;
        const dash = (displayPct / 100) * circ;

        const remaining = maxentry - totalentry;

        return (
            <div style={{ ...allborder, background: "#fff", borderRadius: 16, padding: '24px 24px 48px 24px', display: "flex", flexDirection: "column", gap: 12, position: 'relative', overflow: 'hidden' }}>
                {generatetoprighticon(PLANNING_GUESTBOOK_ICON, 'Guest Book', 'Collect messages from your guests.', '')}
                {status_dom}
                {drawbookid.length > 0
                    ? <>



                        <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Chart</div>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <svg width={140} height={140}>
                                <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e8e8e8" strokeWidth={stroke} />
                                {totalentry > 0 && (
                                    <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--maindark)" strokeWidth={stroke}
                                        strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
                                        transform={`rotate(-90 ${cx} ${cy})`} />
                                )}
                                <text x={cx} y={cy - 6} textAnchor="middle" fontSize={22} fontWeight={700} fill="var(--maindark)" fontFamily="'Playfair Display', serif">{totalentry}</text>
                                <text x={cx} y={cy + 14} textAnchor="middle" fontSize={11} fill="var(--subtitledark)" fontFamily="'DM Sans', sans-serif">Total Entries</text>
                            </svg>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            {[
                                { label: "Entries", count: totalentry, color: "var(--maindark)" },
                                { label: "Remaining", count: remaining, color: "#ccc" }
                            ].map(row => (
                                <div key={row.label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <div style={{ width: 10, height: 10, borderRadius: "50%", background: row.color }} />
                                        <span style={{ fontSize: 13, color: "#555", fontFamily: "'DM Sans', sans-serif" }}>{row.label}</span>
                                    </div>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{row.count}</span>
                                </div>
                            ))}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 13, color: "#555", fontFamily: "'DM Sans', sans-serif" }}>Max Entries</span>
                                </div>
                                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{maxentry}</span>
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                className='dashboard-redirectbtn'
                                onClick={() => window.open('/guestbook/' + url + '/' + passcode, '_blank')}
                            >
                                Guestbook
                            </button>
                            <button
                                className='dashboard-redirectbtn'
                                onClick={() => window.open('/guestbooklookup/' + url + '/' + passcodemod, '_blank')}
                            >
                                Lookup
                            </button>
                            <button
                                className='dashboard-editbtn'
                                onClick={() => window.open('/tools/guestbookbuilder/' + id + '/edit', '_blank')}
                            >
                                Edit
                            </button>
                        </div>
                    </>
                    : <button
                        className='dashboard-create'
                        onClick={() => props.history.push('/tools/guestbook')}
                    >

                        + Create Guestbook
                    </button>}

                <Dot allids={allids} item={'db_ids'} id={drawbookid} left={() => { leftandright('db_ids', drawbookid, allids, 'left', updateDashboard) }} right={() => { leftandright('db_ids', drawbookid, allids, 'right', updateDashboard) }} />
            </div>
        )
    }

    function ItineraryCard() {
        return (
            <div style={{ ...allborder, background: "#fff", borderRadius: 16, padding: '24px 24px 48px 24px', display: "flex", flexDirection: "column", gap: 12, position: 'relative', overflow: 'hidden' }}>
                {generatetoprighticon(PLANNING_TIMELINE_ICON, 'Timeline Itinerary', 'Plan and share your wedding day schedule.', '')}

                {(timelinecornerimg.length > 0 && timelinebanner.length > 0)
                    ? <div className='dashboard-templatedesignroot'>
                        <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Design</div>
                        <div className='dashboard-templatedesign'>
                            <img className='dashboard-designart' src={timelinecornerimg} />
                            <img className='dashboard-designsep' src={timelinebanner} />
                        </div>
                    </div>
                    : <div className='dashboard-templatedesignroot'>
                        <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Design</div>
                        <div className='dashboard-templatedesign' style={{ width: '100%' }}>
                            EMPTY
                        </div>
                    </div>}


                {timelineurl
                    ? <>
                        {/* Snippets */}
                        {timelinesnippets.length > 0
                            ? <div style={{ display: "flex", flexDirection: "column", }}>
                                <div style={{ fontSize: 10, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif", }}>Timeline</div>
                                {timelinesnippets.slice(0, 3).map((item, i) => (
                                    <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                                        {/* Timeline dot + line */}
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: 3, flexShrink: 0, alignSelf: "stretch" }}>
                                            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--mainpink)", flexShrink: 0 }} />
                                            {i < Math.min(timelinesnippets.length, 3) - 1 && (
                                                <div style={{ width: 1, flex: 1, background: "var(--mainpink)", marginTop: 3 }} />
                                            )}
                                        </div>
                                        {/* Text */}
                                        <div style={{ display: "flex", flexDirection: "column", gap: 2, paddingBottom: 8 }}>
                                            <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{item.title}</span>
                                            <span style={{
                                                fontSize: 11,
                                                color: "#999",
                                                fontFamily: "'DM Sans', sans-serif",
                                                lineHeight: 1.4,
                                                display: '-webkit-box',
                                                WebkitLineClamp: 3,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                whiteSpace: 'pre'
                                            }}>
                                                {item.description}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                                {timelinesnippets.length > 3 && (
                                    <span style={{ fontSize: 11, color: "#aaa", fontFamily: "'DM Sans', sans-serif", paddingLeft: 18 }}>
                                        +{timelinesnippets.length - 3} more items
                                    </span>
                                )}
                            </div>
                            : <div className='dashboard-websiteurllabel' style={{ backgroundColor: '#fff', border: '1px dashed var(--lightdark)' }}>
                                Nothing to show just yet — need more data 🙂
                            </div>
                        }

                        <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                            <button
                                className='dashboard-redirectbtn'
                                onClick={() => window.open('/timelinelookup/' + timelineurl + '/passcode=' + timelinepasscode, '_blank')}
                            >
                                View
                            </button>
                            <button
                                className='dashboard-editbtn'
                                onClick={() => window.open('/tools/itinerarybuilder/' + timelineid + '/edit', '_blank')}
                            >
                                Edit
                            </button>
                        </div>
                    </>
                    // : <button
                    //     onClick={() => props.history.push('/timeline')}
                    //     style={{ padding: "10px 0", border: "1px dashed #ccc", borderRadius: 10, background: "#fafafa", cursor: "pointer", fontSize: 13, fontWeight: 600, color: "#666", fontFamily: "'DM Sans', sans-serif" }}
                    // >
                    //     + Create Itinerary
                    // </button>

                    : <button
                        className='dashboard-create'
                        onClick={() => props.history.push('/tools/itinerary')}
                    >

                        + Create Itinerary
                    </button>

                }
                <Dot allids={allids} item={'tl_ids'} id={timelineid} left={() => { leftandright('tl_ids', timelineid, allids, 'left', updateDashboard) }} right={() => { leftandright('tl_ids', timelineid, allids, 'right', updateDashboard) }} />

            </div>
        )
    }

    function VendorTable({ vendors }) {
        const [search, setSearch] = useState("")
        const filtered = vendors.filter(v =>
            v.category.toLowerCase().includes(search.toLowerCase()) ||
            v.name.toLowerCase().includes(search.toLowerCase())
        )

        return (
            <div style={{ ...allborder, background: "#fff", borderRadius: 16, padding: 24, display: "flex", flexDirection: "column", gap: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: 16, fontFamily: "'Playfair Display', serif", color: "var(--maindark)" }}>Vendor Marketplace</div>
                        <div style={{ fontSize: 12, color: "var(--subtitledark)", fontFamily: "'DM Sans', sans-serif" }}>Manage and discover professional services</div>
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, border: "1px solid #e0e0e0", borderRadius: 8, padding: "8px 12px", background: "#fafafa" }}>
                            <span style={{ fontSize: 14 }}>🔍</span>
                            <input
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                placeholder="Search categories..."
                                style={{ border: "none", background: "transparent", outline: "none", fontSize: 13, fontFamily: "'DM Sans', sans-serif", width: 140 }}
                            />
                        </div>
                        <button style={{ padding: "8px 16px", background: "var(--maindark)", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>Filter</button>
                    </div>
                </div>

                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                {["CATEGORY", "VENDOR NAME", "RATING", "STATUS", "ESTIMATE"].map(col => (
                                    <th key={col} style={{ textAlign: "left", fontSize: 11, fontWeight: 600, letterSpacing: 1, color: "#aaa", padding: "0 12px 12px", fontFamily: "'DM Sans', sans-serif", borderBottom: "1px solid var(--lightdark)" }}>{col}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map(v => {
                                const sc = statusColor(v.status)
                                return (
                                    <tr key={v.id} style={{ borderBottom: "1px solid #f9f9f9", cursor: "pointer" }}
                                        onMouseOver={e => e.currentTarget.style.background = "#fafafa"}
                                        onMouseOut={e => e.currentTarget.style.background = "transparent"}>
                                        <td style={{ padding: "16px 12px", fontSize: 13, color: "#555", fontFamily: "'DM Sans', sans-serif" }}>{v.category}</td>
                                        <td style={{ padding: "16px 12px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                <div style={{ width: 36, height: 36, borderRadius: 8, background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{v.avatar}</div>
                                                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{v.name}</span>
                                            </div>
                                        </td>
                                        <td style={{ padding: "16px 12px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                                <span style={{ color: "#f1c40f" }}>⭐</span>
                                                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif" }}>{v.rating}</span>
                                            </div>
                                        </td>
                                        <td style={{ padding: "16px 12px" }}>
                                            <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, background: sc.bg, color: sc.color, fontFamily: "'DM Sans', sans-serif" }}>{v.status}</span>
                                        </td>
                                        <td style={{ padding: "16px 12px", fontSize: 13, fontWeight: 600, color: "var(--maindark)", fontFamily: "'DM Sans', sans-serif", textAlign: "right" }}>{v.estimate}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>

                <div style={{ textAlign: "center" }}>
                    <button style={{ fontSize: 13, fontWeight: 600, color: "var(--maindark)", background: "none", border: "none", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", textDecoration: "underline" }}>Browse More Vendors</button>
                </div>
            </div>
        )
    }

    // ── Main Dashboard ─────────────────────────────────────────────────────────
    return <div style={{
        minHeight: "100vh", padding: "0px 10px 24px 10px", boxSizing: "border-box", fontFamily: 'Lato',
    }}>
        <div style={{ maxWidth: 1080, margin: "0 auto", display: "flex", flexDirection: "column", gap: 20 }}>

            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-start" }}>
                <ProfileCard />
                <BudgetCard />
            </div>

            <WebsiteGuestlist />

            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                <div style={{ flex: "1 1 220px", minWidth: 300 }}>
                    <SeatingCard />
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 300 }}>
                    <ChecklistCard />
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 300 }}>
                    <DrawbookCard />
                    {/* <GuestbookCard entries={GUESTBOOK.entries} totalLimit={GUESTBOOK.totalLimit} /> */}
                </div>
            </div>

            <ItineraryCard />
            {/* <VendorTable vendors={VENDORS} /> */}

        </div>
    </div>


}

export default withRouter(Dashboard)